<template>
<div>
    <smallbutton toplabel="Add Wallet & Account" @click="startUpdateStudent()" v-if="showButton"/>
    <!-- MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form id="updatestudentform" ref="updatestudentform" @submit.prevent>
                <label class="titlelabel">Add Wallet and Account</label>
                <formentry inputid="firstname" :label="studentfirstNameLabel" :isrequired='trueParam' v-model="student.FirstName" />
                <formentry inputid="lastname" :label="studentlastNameLabel" :isrequired='trueParam' v-model="student.LastName"  />

                <div class="entry">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="roleselect">Role</label>
                    </div>
                    <select name="" id="roleselect" class='entrySelect' v-model="student.personRoleId" required v-if='allowSelectPersonRole'>
                        <option v-for="role in personRoleList" :key="role.id" :value="role.id" >
                            {{role.name}}
                        </option>
                    </select>
                </div>

                <formentry inputid="studentid" :label="studentIDLabel" :isrequired="requireStudentID" v-model="student.StudentID"/>
                <formentry inputid="phonenumber" inputtype="tel"  label="Phone Number"   v-model="student.PhoneNumber1" />
                <formentry inputid="emailaddress" inputtype="email"  label="Email Address"  v-model="student.EmailAddress" :isrequired='trueParam'/>
                <formentry inputid="internalid" :label="idLabel"  v-model="student.InternalID"/>
                <formentry inputid="fid" :label="fidLabel" :isrequired='requireFID'    v-model="student.fId" v-if="showFID" :placeholder="FIDPlaceholder"/>
                <formentry inputid="preferredname" :label="studentPreferredLabel"  v-model="student.PreferredFirstName"/>

                

                <formentry inputid="addressline1" label="Address 1"  v-model="student.AddressLine1"/>
                <formentry inputid="addressline2" label="Address 2"  v-model="student.AddressLine2"/>
                <formentry inputid="city" label="City"  v-model="student.City"/>
                <div class="entry">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="stateselect">State</label>
                    </div>
                    <select name="" id="stateselect" class='entrySelect' v-model="student.StateID" >
                        <option v-for="state in states" :key="state.id" :value="state.id" >
                            {{state.name}}
                        </option>
                    </select>
                </div>
                <formentry inputid="zipcode" label="Zip"  v-model="student.ZipCode"/>
                <formentry inputid="password"  inputtype="password"  label="Password" :isrequired='trueParam' v-model="student.password" />
                <formentry inputid="password2" inputtype="password"  label="Confirm Password" :isrequired='trueParam' v-model="student.confirmPassword" />
                <div class="vertFlex ">
                    <label  class="" v-if="showOptInEmail || showOptInSMS">Student agrees to receive communications through</label>
                    <label  class="" v-if="showOptInEmail && showOptInSMS">(Check at least one)</label>
                
                    <div class="horizFlex centered" v-if="showOptInEmail">
                        <input id="optinemailcheck" class="entryCheckbox" type="checkbox" v-model="student.optInForEmail" >
                        <label for="optinemailcheck" :class="checkClass(student.optInForEmail)">Email</label>
                    </div>

                    <div class="horizFlex topMargin centered" v-if="showOptInSMS">
                        <input id="optinsmscheck" class="entryCheckbox" type="checkbox" v-model="student.optInForText" >
                        <label for="optinsmscheck" :class="checkClass(student.optInForText)">Text Messaging</label>
                    </div>
                    <label v-if="showOptInSMS"  class="">(Student has given you consent to send text messages and understands that standard messaging and data rates may apply)</label>
                    

    
                </div> 

                <smallbutton  @click="saveUpdatedStudent()" toplabel="Save" />
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Cancel"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
            </form>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import pencilbutton from '../controls/pencilbutton.vue'
import wallethelper from '../../wallethelper.js'
export default {
    name:'walletaccount',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        pencilbutton
    },
    props:{
        showButton:{
            type:Boolean,
            default:true
        }
  
        
    },
    mixins:[datamethods,format,wallethelper],
    data(){
        return{
            responseMessage:'',

            student:{},

            
            studentfirstNameLabel:'First Name',
            studentlastNameLabel:'Last Name',
            studentPreferredLabel:'Preferred Name (Nickname)',

            states:[],

            fidLabel:'SSN',

            personRoleList:[],
            personRoleId:0,
            trueParam:true,
            falseParam:false
            
        }
    },
    computed:{
        requireStudentID(){
            if(window.REQUIRESTUDENTID==undefined){return false}
            if(!window.REQUIRESTUDENTID){return false}

            //if the main setting says yes, check for exceptions
            var req = this.isRoleThatDoesNOTRequireID(this.student.personRoleId)
             console.log(' require id ' + !req)
            return !req

      
           
 
        },
        showOptInEmail(){
            if(window.SHOW_OPTIN_EMAIL==undefined){return false}
            else{return window.SHOW_OPTIN_EMAIL}
        },
        showOptInSMS(){
            if(window.SHOW_OPTIN_SMS==undefined){return false}
            else{return window.SHOW_OPTIN_SMS}
        },
        allowSelectPersonRole(){
            if(window.ALLOW_SELECT_PERSON_ROLE==undefined){return false}
            else{return window.ALLOW_SELECT_PERSON_ROLE}
        },
        studentIDLabel(){
            if(this.requireStudentID){return 'School ID'}else{return 'School ID (optional)'}
        },
        requireFID(){
            if(window.REQUIRE_SSN==undefined){return false}
            else if(window.REQUIRE_SSN){return true}
            else{return false}
        },
        showFID(){
            if(window.SHOW_SSN==undefined){return false}
            else{return window.SHOW_SSN=="True"}
        },
        FIDPlaceholder(){
            var placeholder=''
            if(window.SSN_LENGTH==undefined){placeholder='last 4 digits'}
            else if(window.SSN_LENGTH==4){placeholder='last 4 digits'}
            else{placeholder=window.SSN_LENGTH + ' digits'}
            return placeholder
        },
        FIDLength(){
            var l=4
            if(window.SSN_LENGTH!=undefined){l=window.SSN_LENGTH}
            return l
        },
        idLabel(){
            var l = "Permit #"
            if(window.ID_LABEL_OVERRIDE!=undefined){
                if(window.ID_LABEL_OVERRIDE!=''){
                    l=window.ID_LABEL_OVERRIDE
                }
            }
            return l
        },
    },
    methods:{
        
     
        checkClass(selected){
            if(selected){
                return "entryCheckLabelbold"
            }else{
                return "entryCheckLabel"
            }
        },
        isOKFID(fid){
            if(fid==null){return true}
            fid = fid.replaceAll('-','').replaceAll('.','').replaceAll(' ','')
            console.log(fid.length)
            return fid.length==this.FIDLength
        },
        async getstates(){
            this.message = ''
            var response = await this.callAPI(null,'states')    
            if(response.Successful){
                this.states=response.stateList
            }else{
                this.message = response.Message
            }

        },
        async startUpdateStudent(){
            this.getstates()
            this.getRoles()
            this.message = ''
            
            this.student={
                FirstName:'',
                LastName:'',
                PhoneNumber1:'',
                EmailAddress:'',
                optInForEmail:false,
                optInForText:false,
                password:'',
                confirmPassword:''
            }


            this.$refs.mymodal.openModal()
       

        },
     
        async saveUpdatedStudent(){
            if(this.$refs.updatestudentform.checkValidity()==false){return}

                if(!this.isOKFID(this.student.fId)){
                    if(this.FIDLength==4){
                        this.responseMessage="Please enter the last 4 digits of your SSN"
                    }else{
                        this.responseMessage="Please enter a " + this.FIDLength + ' digit SSN'
                    }
                }

            let req = {
                person:this.student,
            }
            var response 
            if(this.isRoleThatGetsAccount(this.student.personRoleId)){
                response=  await this.callAPI(req,'addpersonwalletaccount')
            }else{
                response= await this.callAPI(req,'addpersonandwallet')
            }
            
            
            if(response.Successful){
                this.$refs.mymodal.closeModal()
                console.log(response)
                this.$emit('refresh',response.walletId)
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        async getRoles(){
            let req = {
                locationId:-1
            }
            //this.beforeAPI();
            var response = await this.callAPI(req,'rolelist')

            //handle response
            if(response.Successful){
            this.personRoleList = response.PersonRoleList
    
            if(this.personRoleList.length>0){
               //find student and pick it as default
                var studentId=-1
                this.personRoleList.forEach(myFunction2)

                function myFunction2(item, index, arr) {
                    let acct=arr[index]
                    if(acct.name=='Student'){
                        studentId=acct.id
                    }
                }
                //this.personRoleId=studentId 
            }
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
       
    }
}
</script>

<style>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
</style>





























